var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlaska529GoTuition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 234 54",
    style: {
      enableBackground: "new 0 0 234 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#92BF54;}\n\t.st1{fill:#00496A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbols_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-_x2F_-nav-_x2F_-mobile-_x2F_-color_1_",
    transform: "translate(-127.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "go-tuition-logo_1_",
    transform: "translate(127.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg_2_",
    className: "st0",
    fill: "#92BF54",
    d: "M5.5,0.55h223c1.94,0,3.5,1.57,3.5,3.5v45.89c0,1.94-1.57,3.5-3.5,3.5H5.5 c-1.94,0-3.5-1.57-3.5-3.5V4.05C2,2.12,3.57,0.55,5.5,0.55z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "GoTuition_2_",
    transform: "translate(5.996351, 6.613333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18_2_",
    transform: "translate(1.131133, 0.810667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G_2_",
    className: "st1",
    fill: "#00496A",
    d: "M30.89,17.93v12.2c-1.25,0.58-2.72,1.04-4.39,1.36c-1.67,0.33-3.39,0.49-5.15,0.49 c-2.72,0-5.08-0.51-7.08-1.54c-2-1.03-3.54-2.49-4.61-4.4s-1.61-4.2-1.61-6.85c0-2.59,0.54-4.84,1.61-6.75 s2.59-3.39,4.55-4.42s4.26-1.56,6.88-1.56c1.85,0,3.58,0.24,5.19,0.73c1.6,0.49,2.92,1.18,3.96,2.06l-1.81,3.92 c-1.2-0.84-2.37-1.45-3.51-1.82s-2.36-0.56-3.69-0.56c-4.96,0-7.44,2.8-7.44,8.39c0,5.71,2.59,8.57,7.77,8.57 c1.42,0,2.84-0.17,4.26-0.52v-5.49h-5.06v-3.81C20.76,17.93,30.89,17.93,30.89,17.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O_2_",
    className: "st1",
    fill: "#00496A",
    d: "M38.71,30.83c-1.46-0.75-2.58-1.82-3.36-3.22s-1.17-3.03-1.17-4.89c0-1.86,0.39-3.5,1.17-4.89 c0.78-1.4,1.9-2.47,3.36-3.22s3.16-1.12,5.11-1.12c1.93,0,3.61,0.37,5.06,1.12s2.56,1.82,3.34,3.22s1.17,3.03,1.17,4.89 c0,1.86-0.39,3.5-1.17,4.89c-0.78,1.4-1.9,2.47-3.34,3.22c-1.45,0.75-3.13,1.12-5.06,1.12 C41.87,31.95,40.17,31.58,38.71,30.83z M46.92,26.64c0.71-0.86,1.07-2.17,1.07-3.92c0-1.72-0.36-3.02-1.07-3.9 s-1.74-1.31-3.09-1.31c-1.37,0-2.42,0.44-3.14,1.31c-0.72,0.87-1.08,2.17-1.08,3.9c0,3.47,1.41,5.21,4.23,5.21 C45.17,27.93,46.2,27.5,46.92,26.64z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_16_",
    className: "st1",
    fill: "#00496A",
    points: "61.7,32.65 61.7,9.91 52.7,9.91 52.7,7.43 73.72,7.43 73.72,9.91 64.72,9.91 64.72,32.65  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4_2_",
    transform: "translate(35.780477, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15_",
    className: "st1",
    fill: "#00496A",
    d: "M51.18,14.84v17.82h-2.87v-3.08c-0.58,1.09-1.39,1.91-2.43,2.48s-2.21,0.85-3.52,0.85 c-2.15,0-3.79-0.59-4.9-1.77s-1.67-2.93-1.67-5.24V14.84h2.94v10.98c0,1.61,0.34,2.79,1.02,3.54 c0.68,0.76,1.71,1.13,3.09,1.13c1.62,0,2.93-0.51,3.92-1.54s1.49-2.38,1.49-4.06V14.84H51.18z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_14_",
    className: "st1",
    fill: "#00496A",
    points: "56.3,32.65 56.3,14.84 59.24,14.84 59.24,32.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_13_",
    className: "st1",
    fill: "#00496A",
    points: "56.01,7.29 59.61,7.29 59.61,10.55 56.01,10.55  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12_",
    className: "st1",
    fill: "#00496A",
    d: "M69.63,17.1v9.74c0,1.32,0.28,2.25,0.84,2.78s1.34,0.8,2.36,0.8 c0.68,0,1.33-0.11,1.96-0.32v2.44c-0.75,0.24-1.6,0.35-2.54,0.35c-1.74,0-3.1-0.48-4.08-1.43s-1.47-2.37-1.47-4.23V17.1h-3.56 v-2.27h3.56v-4.57l2.94-1.03v5.6h5.23v2.27H69.63z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_11_",
    className: "st1",
    fill: "#00496A",
    points: "79.29,32.65 79.29,14.84 82.23,14.84 82.23,32.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_10_",
    className: "st1",
    fill: "#00496A",
    points: "79,7.29 82.59,7.29 82.59,10.55 79,10.55  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_2_",
    className: "st1",
    fill: "#00496A",
    d: "M89.95,31.77c-1.31-0.76-2.32-1.83-3.03-3.22s-1.07-3.02-1.07-4.89 c0-1.87,0.36-3.49,1.07-4.89c0.71-1.39,1.72-2.47,3.03-3.22c1.31-0.76,2.82-1.13,4.54-1.13s3.23,0.38,4.54,1.13 c1.31,0.76,2.32,1.83,3.03,3.22s1.07,3.02,1.07,4.89c0,1.87-0.36,3.49-1.07,4.89s-1.72,2.47-3.03,3.22 c-1.31,0.76-2.82,1.13-4.54,1.13S91.25,32.52,89.95,31.77z M98.66,28.77c0.97-1.17,1.45-2.87,1.45-5.12 c0-2.17-0.5-3.85-1.49-5.05c-0.99-1.19-2.37-1.79-4.14-1.79c-1.79,0-3.18,0.6-4.18,1.79c-0.99,1.19-1.49,2.87-1.49,5.05 c0,2.24,0.49,3.95,1.47,5.12s2.38,1.75,4.19,1.75C96.3,30.53,97.69,29.94,98.66,28.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9_",
    className: "st1",
    fill: "#00496A",
    d: "M122.14,21.46v11.19h-2.94V21.6c0-1.65-0.34-2.86-1.02-3.63c-0.68-0.77-1.74-1.15-3.2-1.15 c-1.69,0-3.05,0.51-4.07,1.52c-1.02,1.02-1.52,2.38-1.52,4.11v10.2h-2.94V19.83c0-1.84-0.1-3.51-0.29-4.99h2.8l0.29,3.19 c0.56-1.16,1.39-2.05,2.51-2.67c1.11-0.63,2.38-0.94,3.81-0.94C119.95,14.41,122.14,16.76,122.14,21.46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "giftbox_2_",
    transform: "translate(96.158192, 3.840000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-5_4_",
    className: "st1",
    fill: "#00496A",
    d: "M78.63,15.12c0-0.64,0.53-1.16,1.17-1.16h12.84v4.6H79.8 c-0.65,0-1.17-0.53-1.17-1.16C78.63,17.4,78.63,15.12,78.63,15.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st1",
    fill: "#00496A",
    d: "M91.36,11.12c0,0-5.42-0.49-5.71-2.11s2.9-4.48,4.57-4.23c1.67,0.26,2.17,4.62,2.29,5.28 C92.62,10.72,91.36,11.12,91.36,11.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4_",
    className: "st1",
    fill: "#00496A",
    d: "M80.96,22.01h11.67v14.95H82.12c-0.64,0-1.16-0.53-1.16-1.17V22.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5_3_",
    transform: "translate(13.644068, 9.600000) scale(-1, 1) translate(-13.644068, -9.600000) translate(9.745763, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-5_3_",
    className: "st1",
    fill: "#00496A",
    d: "M-92.61,15.12c0-0.64,0.53-1.16,1.17-1.16h12.84v4.6h-12.84 c-0.65,0-1.17-0.53-1.17-1.16V15.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st1",
    fill: "#00496A",
    d: "M-79.87,11.12c0,0-5.42-0.49-5.71-2.11s2.9-4.48,4.57-4.23c1.67,0.26,2.17,4.62,2.29,5.28 S-79.87,11.12-79.87,11.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3_",
    className: "st1",
    fill: "#00496A",
    d: "M-90.27,22.01h11.67v14.95h-10.51c-0.64,0-1.16-0.53-1.16-1.17 C-90.27,35.79-90.27,22.01-90.27,22.01z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#00496A",
    d: "M219.83,12.16c0,2.89-2.35,5.23-5.23,5.23s-5.23-2.35-5.23-5.23c0-2.93,2.35-5.25,5.31-5.25 C217.49,6.91,219.83,9.29,219.83,12.16z M210.17,12.16c0,2.48,2,4.5,4.44,4.5c2.45,0,4.44-2.01,4.44-4.51 c0-2.45-1.98-4.5-4.38-4.5C212.15,7.65,210.17,9.63,210.17,12.16z M215.1,9.27c0.57,0,0.9,0.08,1.22,0.26 c0.5,0.29,0.77,0.75,0.77,1.34c0,0.65-0.27,1.08-0.86,1.37c0.59,0.29,0.69,0.53,0.78,1.74c0.05,0.48,0.11,0.71,0.21,0.86l0.2,0.2 h-1.11c-0.12-0.15-0.18-0.39-0.2-0.74c-0.08-1.5-0.24-1.7-1.37-1.7h-1.52v2.44h-0.93V9.28h2.81V9.27z M213.22,11.86h1.43 c1.11,0,1.5-0.24,1.5-0.92c0-0.63-0.36-0.89-1.29-0.89h-1.64V11.86z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlaska529GoTuition);
export default __webpack_public_path__ + "static/media/alaska-529-go-tuition.622072e454b82588e8987464f2bc2671.svg";
export { ForwardRef as ReactComponent };